import React from 'react'
import useCurrentHcs from '../../../../hooks/useCurrentHcs'
import PatientIdentityVerificator from './PatientIdentityVerificator'
import useStyles from './_styles/PatientIdentityStyles'
import PatientIdentityDocument from './PatientIdentityDocument'
import PatientIdentityAttributes from './PatientIdentityAttributes'
import insi from '../../../../utils/insi'
import { usePatientFormContext } from '../../context/PatientFormContext'
import { PatientIdentityProps } from './_props'
import { useFormContextPatient } from '../_utils'
import useHandleIdentityPropsChange from './_utils/useHandleIdentityPropsChange'
import useCurrentUser from '../../../../hooks/useCurrentUser'

const PatientIdentity = ({
    isLocked,
    setIdentity,
    onIdentityCheck,
    onManualIdentityValidation,
    onInsiSuccess,
}: PatientIdentityProps) => {
    const classes = useStyles()
    const currentHcs = useCurrentHcs()

    const { handleIdentityPropsChange } = useHandleIdentityPropsChange()

    const user = useCurrentUser()
    const { state, update } = usePatientFormContext()

    const { watch, getValues } = useFormContextPatient()

    const getWatchedValues = () => {
        const watchedIdentityProofAttributesCodes = watch('insiIdentityAttributes')
        const watchedIdentityProofCode = watch('identityProof')

        const identityProofCode = watchedIdentityProofCode?.level || undefined
        const identityAttributesCodes = watchedIdentityProofAttributesCodes

        return {
            identityProofCode,
            identityAttributesCodes,
        }
    }

    const watchedValues = getWatchedValues()

    const handleChangeIdentityPropsChange = async () => {
        const { identityProofCode, identityAttributesCodes } = getWatchedValues()

        const slug = await handleIdentityPropsChange({
            identityProofCode,
            identityAttributesCodes,
            originalIdentityCode: state.originalIdentityStatus?.code,
            insOid: getValues('insOid') ?? '',
        })
        await setIdentity(slug)
    }

    React.useEffect(() => {
        const isAlive = async () => {
            update({
                ins: {
                    ...state.ins,
                    isGettingConnector: true,
                },
            })
            const storedData = insi.getStoredData(user)
            const isDmpConnectorAlive = await insi.checkDmpConnectJsServiceAvailable()
            update({
                ins: {
                    ...state.ins,
                    storedData,
                    isDmpConnectorAlive,
                    isGettingConnector: false,
                },
            })
        }

        isAlive()
    }, [])

    const displayVerificator = !(
        watchedValues.identityAttributesCodes?.includes(3) ||
        watchedValues.identityAttributesCodes?.includes(2) ||
        currentHcs.isSynchroServiceEnabled
    )

    return (
        <div className={classes.PatientIdentity}>
            <div className={classes.PatientIdentitySection}>
                {displayVerificator && (
                    <PatientIdentityVerificator
                        isLocked={currentHcs.isSynchroServiceEnabled || isLocked}
                        setIdentity={setIdentity}
                        onIdentityCheck={onIdentityCheck}
                        onInsiSuccess={onInsiSuccess}
                    />
                )}
                <PatientIdentityDocument onChange={handleChangeIdentityPropsChange} />
                <PatientIdentityAttributes
                    onChange={handleChangeIdentityPropsChange}
                    onManualIdentityValidation={onManualIdentityValidation}
                />
            </div>
        </div>
    )
}

export default PatientIdentity
